import React from 'react';
import PropTypes from 'prop-types';
import AdvancedMode from './modes/Advanced';
import BasicMode from './modes/Basic';

/**
 * Default name for the form with filters.
 */
const formName = 'filterForm';

/**
 * This component will use the category property and check in the categoryMapping which Component to build up.
 *
 * @param {Object} props
 */
const FilterContent = (props) => {
    const { category } = props;

    if (!category) {
        return null;
    }

    const categoryMapping = {
        basic: BasicMode,
        advanced: AdvancedMode,
    };

    const Component = categoryMapping[category];

    return <Component
        { ...props }
        form={ formName }
    />;
};

FilterContent.propTypes = {
    category: PropTypes.string.isRequired,
};

export default FilterContent;



// WEBPACK FOOTER //
// ./src/components/list/Filters/FilterContent.js